export default __webpack_public_path__ + "mic-off.svg";